import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

const Requisitions = () => import("../pages/Warehouse/Requisitions/");
const SinisterList = () => import("../pages/Warehouse/SinisterWithoutMaterialListing/index");
const Warehouse = () => import("../pages/Purchases/Warehouse/Index");
const ModifyWarehouse = () =>
  import("../pages/Purchases/Warehouse/modifyWarehouse");
const warehouseReleases = () => import("../pages/Warehouse/WarehouseReleases/");
const ExtraWarehouseReleases = () =>
  import("../pages/Warehouse/ExtraWarehouseReleases/");
const materialInputs = () => import("../pages/Warehouse/MaterialInputs/");

const warehousePages = {
  path: "/",
  component: DashboardLayout,
  name: "warehousePages",
  title: "Inventario",
  icon: "category",
  meta: {
    ifUserCan: {
      // view: 'Provider/provider',
    },
  },
  excludedGroups: ["Extranet"],
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/warehouse",
      name: "Almacenes",
      title: "Almacenes",
      component: Warehouse,
      meta: {
        ifUserCan: {
          can_view_warehouses_list: "IWarehouse/iwarehouse",
        },
      },
    },
    {
      path: "/warehouse/editar/:id",
      name: "Modificar Almacén",
      component: ModifyWarehouse,
      meta: {
        ifUserCan: {
          view: "IWarehouse/iwarehouse",
        },
      },
    },
    {
      path: "/almacen/siniestros",
      name: "Listado de siniestros",
      title: "Listado de siniestros",
      meta: {
        ifUserCan: {
          can_view_sm_list: "IWarehouse/iwarehousequantification",
        },
      },
      component: SinisterList,
    },
    {
      path: "/almacen/requisiciones",
      name: "Listado de requisiciones",
      title: "Listado de requisiciones",
      meta: {
        ifUserCan: {
          view: "IWarehouse/iwarehouserequisition",
        },
      },
      component: Requisitions,
    },
    {
      path: "/almacen/salidas",
      name: "Salidas de material",
      title: "Salidas de material",
      meta: {
        ifUserCan: {
          can_view_outputs: "IWarehouse/iwarehouse",
        },
      },
      component: warehouseReleases,
    },
    {
      path: "/almacen/extra/salidas",
      name: "Salidas extra de material",
      title: "Salidas extra de material",
      meta: {
        ifUserCan: {
          can_view_outputs: "IWarehouse/iwarehouse",
        },
      },
      component: ExtraWarehouseReleases,
    },
    {
      path: "/almacen/devoluciones",
      name: "Devoluciones de material",
      title: "Devoluciones de material",
      meta: {
        ifUserCan: {
          can_view_material_returns: "IWarehouse/iwarehouse",
        },
      },
      component: materialInputs,
    },
    // {
    //   path: "/almacen/stock",
    //   name: "Stock de almacén",
    //   title: "Stock de almacén",
    //   roles: ["ADMIN"],
    //   meta: {
    //     ifUserCan: {
    //       can_view_material_returns: "IWarehouse/iwarehouse",
    //     },
    //   },
    //   component: Stock,
    // },
  ],
};

export default warehousePages;



// WEBPACK FOOTER //
// ./src/router/warehouseRoutes.js